/* Charmant — comportamiento del menú móvil.
   Sustituye a los dos scripts que iban incrustados en theme.liquid.

   Cierra el menú hamburguesa al pinchar fuera de él (incluida la lupa,
   que abre la búsqueda). A diferencia del parche antiguo —que quitaba
   [open] en seco y dejaba el foco atrapado— aquí se llama a
   closeMenuDrawer() de Dawn, que reproduce la animación de cierre,
   libera el focus trap y devuelve el foco al botón del menú. */

(function () {
  'use strict';

  document.addEventListener(
    'click',
    function (event) {
      document.querySelectorAll('header-drawer').forEach(function (drawer) {
        var details = drawer.querySelector('details[open]');
        if (!details) return;

        var summary = details.querySelector('summary');
        var menu = details.querySelector('.menu-drawer');
        if (menu && menu.contains(event.target)) return;
        if (summary && summary.contains(event.target)) return;

        if (typeof drawer.closeMenuDrawer === 'function') {
          drawer.closeMenuDrawer(event, summary);
        } else {
          /* Red de seguridad por si el componente de Dawn no está definido */
          details.classList.remove('menu-opening');
          details.removeAttribute('open');
          document.body.classList.remove(
            'overflow-hidden-mobile',
            'overflow-hidden-tablet',
            'overflow-hidden-desktop'
          );
        }
        if (summary) summary.setAttribute('aria-expanded', 'false');

        /* El clic sobre la capa oscura (pseudo-elemento de details) no
           debe llegar a nada más */
        if (event.target === details) {
          event.preventDefault();
          event.stopPropagation();
        }
      });
    },
    true
  );

  /* ------------------------------------------------------------
     Barra pegajosa de compra en la ficha de producto (solo móvil).
     Se muestra cuando el botón principal de añadir sale de pantalla
     y reenvía el clic al formulario real (con la talla elegida).
     ------------------------------------------------------------ */
  function initStickyAtc() {
    var bar = document.getElementById('CharmantStickyAtc');
    if (!bar) return;
    var productInfo = bar.closest('product-info') || document;
    var mainSubmit = productInfo.querySelector('.product-form__submit');
    var mainForm = mainSubmit && mainSubmit.closest('form');
    if (!mainSubmit || !mainForm || !('IntersectionObserver' in window)) return;

    var stickyBtn = bar.querySelector('.charmant-sticky-atc__button');
    var mobile = window.matchMedia('(max-width: 749px)');

    function syncState() {
      stickyBtn.disabled = mainSubmit.disabled;
      var label = mainSubmit.querySelector('span');
      if (label && label.textContent.trim()) {
        stickyBtn.textContent = label.textContent.trim();
      }
      var price = productInfo.querySelector('.price__container .price-item--regular, .price-item--sale');
      var barPrice = bar.querySelector('.charmant-sticky-atc__price');
      if (price && barPrice) barPrice.textContent = price.textContent.trim();
    }

    var pastButton = false;
    function update() {
      var show = mobile.matches && pastButton;
      if (show) {
        syncState();
        bar.hidden = false;
        requestAnimationFrame(function () { bar.classList.add('is-visible'); });
      } else {
        bar.classList.remove('is-visible');
        bar.hidden = true;
      }
    }

    new IntersectionObserver(
      function (entries) {
        /* solo cuando el botón queda por ENCIMA del viewport (scroll pasado) */
        var e = entries[0];
        pastButton = !e.isIntersecting && e.boundingClientRect.top < 0;
        update();
      },
      { threshold: 0 }
    ).observe(mainSubmit);

    if (mobile.addEventListener) mobile.addEventListener('change', update);

    stickyBtn.addEventListener('click', function () {
      if (typeof mainForm.requestSubmit === 'function') mainForm.requestSubmit();
      else mainSubmit.click();
    });
  }

  /* ------------------------------------------------------------
     Reveal al hacer scroll (rediseño 2026).
     Marca con .is-revealed los elementos [data-charmant-reveal]
     cuando asoman al viewport. El escalonado entre hermanos se
     resuelve en CSS con la variable --ri. Con reduced-motion no
     se observa nada: el CSS ya los deja visibles.
     ------------------------------------------------------------ */
  function initScrollReveal() {
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    var items = document.querySelectorAll('[data-charmant-reveal]');
    if (!items.length) return;

    if (reduced.matches || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-revealed'); });
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-revealed');
          io.unobserve(entry.target);
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
    );
    items.forEach(function (el) { io.observe(el); });
  }

  /* ------------------------------------------------------------
     Marquesina: descanso fuera de pantalla.

     La cinta se mueve siempre mientras se ve; no hay botón de pausa
     (decisión de Sergio del 2/08/2026: se comía el ancho de la cinta).
     Quien lleve activado «reducir movimiento» en su dispositivo la ve
     quieta, eso lo resuelve el CSS.

     Lo único que hace este código es dejarla descansar cuando la sección
     ya no está en pantalla: es la segunda sección de la portada, así que
     sin esto el compositor trabaja en cada fotograma durante toda la
     visita. La clienta no nota nada, porque no se ve.
     ------------------------------------------------------------ */
  function initMarquee() {
    var bandas = document.querySelectorAll('.charmant-marquee');
    if (!bandas.length) return;

    /* Si no hay IntersectionObserver la cinta se queda corriendo, que es
       el comportamiento de siempre: nunca se congela por accidente. */
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          entry.target.classList.toggle('is-offscreen', !entry.isIntersecting);
        });
      },
      { threshold: 0 }
    );
    bandas.forEach(function (banda) { io.observe(banda); });
  }

  function initCharmant() {
    initStickyAtc();
    initScrollReveal();
    initMarquee();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCharmant);
  } else {
    initCharmant();
  }

  /* El editor de temas vuelve a pintar una sección sin recargar la página:
     el HTML nuevo trae [data-charmant-reveal] a opacity 0 y no lo observa
     nadie, así que la sección parece desaparecer mientras Sergio la edita.
     Igual que hace Dawn con .scroll-trigger, dentro del editor los dejamos
     revelados en seco en vez de animarlos. */
  if (window.Shopify && Shopify.designMode) {
    var revealNow = function (root) {
      root.querySelectorAll('[data-charmant-reveal]').forEach(function (el) {
        el.classList.add('is-revealed');
      });
    };

    document.addEventListener('shopify:section:load', function (event) {
      revealNow(event.target);
      initMarquee();

      /* La barra pegajosa vive dentro de main-product. Solo se reengancha
         si es ESA sección la que se ha repintado: initStickyAtc no es
         idempotente y volver a llamarla con la barra vieja aún viva
         duplicaría el listener (y el producto entraría dos veces). */
      var bar = document.getElementById('CharmantStickyAtc');
      if (bar && event.target.contains(bar)) initStickyAtc();
    });

    document.addEventListener('shopify:section:reorder', function () {
      revealNow(document);
    });
  }
})();
